/** Stable key for a dashboard query scope (used to suppress re-fetch after user cancel). */
export function buildDashboardScopeKey(scope, subpath, params = {}, dominioIds = []) {
  const ids = (Array.isArray(dominioIds) ? dominioIds : [])
    .map((x) => Number(x))
    .filter((n) => Number.isFinite(n) && n > 0)
    .sort((a, b) => a - b);

  const filterFingerprint = buildAdvancedFilterFingerprint(params);

  return [
    String(scope || "").trim(),
    String(subpath || "").trim(),
    String(params?.start || params?.startDate || "").trim(),
    String(params?.end || params?.endDate || "").trim(),
    ids.join(","),
    filterFingerprint,
  ].join("|");
}

/** Fingerprint estável dos filtros avançados (CSV arrays ordenados). */
function buildAdvancedFilterFingerprint(params = {}) {
  const keys = [
    "date_field",
    "all_period",
    "ids_status",
    "ids_origens",
    "ids_tipos",
    "ids_subtipo1",
    "ids_subtipo2",
    "ids_subtipo3",
    "ids_usuarios",
    "ids_agentes",
    "ids_usuarios_interacao",
    "ids_agentes_interacao",
    "tags",
    "tipo_responsavel",
    "ids_campaigns",
    "ids_whatsapp_campaigns",
    "ids_motivos",
    "ids_categorias",
    "ids_subcategorias",
    "ids_produtos",
    "availability",
    "ids_motivos",
    "ids_potenciais",
    "ops_preset",
    "stale_days",
    "tipo_scope",
  ];
  const parts = [];
  for (const k of keys) {
    const v = params?.[k];
    if (v == null || v === "") continue;
    if (Array.isArray(v)) {
      const arr = v.map((x) => String(x ?? "").trim()).filter(Boolean).sort();
      if (arr.length) parts.push(`${k}=${arr.join(",")}`);
    } else {
      const s = String(v).trim();
      if (s) parts.push(`${k}=${s}`);
    }
  }
  return parts.join("&");
}

export function buildDashboardScopeKeyFromJob(job) {
  if (!job) return "";
  const route = String(job.route || job.routeKey || "").trim();
  const period = {
    start: job.start || job.scope?.start || job.scope?.startDate || null,
    end: job.end || job.scope?.end || job.scope?.endDate || null,
    ...(job.scope?.query && typeof job.scope.query === "object" ? job.scope.query : {}),
    ...(job.query && typeof job.query === "object" ? job.query : {}),
  };

  if (route === "atendimento:relacionamento:summary") {
    return buildDashboardScopeKey("atendimento", "summary", {
      ...period,
      tipo_scope: period.tipo_scope || "relacionamento",
    });
  }

  if (route.startsWith("surveys:analytics:")) {
    const surveyId = route.slice("surveys:analytics:".length);
    return buildDashboardScopeKey("surveys", `analytics:${surveyId}`, period);
  }

  if (route.startsWith("partner:surveys:")) {
    const surveyKey = route.slice("partner:surveys:".length);
    return buildDashboardScopeKey("surveys", `analytics:${surveyKey}`, period);
  }

  if (route.startsWith("platform:")) {
    const parts = route.split(":");
    const scope = parts[1] || "";
    const subpath = parts.slice(2).join(":") || "";
    const dominioIds = job.scope?.dominio_ids || job.scope?.dominioIds || [];
    return buildDashboardScopeKey(scope, subpath, period, dominioIds);
  }

  if (route.startsWith("partner:")) {
    const parts = route.split(":");
    const scope = parts[1] || "";
    const subpath = parts.slice(2).join(":") || "";
    const dominioIds = job.scope?.dominio_ids || job.scope?.dominioIds || [];
    return buildDashboardScopeKey(scope, subpath, period, dominioIds);
  }

  if (route.includes(":")) {
    const idx = route.indexOf(":");
    const scope = route.slice(0, idx);
    const subpath = route.slice(idx + 1);
    return buildDashboardScopeKey(scope, subpath, period);
  }

  return buildDashboardScopeKey(route, "", period);
}
